import classes from "./css/AboutMe.module.css";

const AboutMePage = () => {
  return (
    <div className={classes.main}>
      <div className={classes.container}>
        <div className={classes.info_about_me}>
          <h2>
            UN ORDINE TEATRALE SI ISTITUISCE SOLAMENTE GRAZIE A UN LUNGO
            DISORDINE <p style={{ fontSize: "0.7em" }}> (Louis Jouvet.)</p>
          </h2>

          <p>
            Il teatro è il disordine incarnato e per scrivere - (o fare) -
            teatro bisogna iniziare con lo scrivere l’elogio del disordine. Il
            teatro vive nel disordine: è la sua condizione di esistenza. La
            grandezza del teatro è fondata su un disordine organico, necessario,
            permanente. (...) Recitare è propriamente una distruzione di sé, una
            demolizione, è un disordine obbligato, l’impossibilità di una vita
            interiore. Anche l’opera del poeta (di un attore) è un disordine.
            Tra la scrittura e la rappresentazione, tessuti di sensazioni e di
            sentimenti intrecciati, l’opera più viva confessa una contraddizione
            permanente, un disordine essenziale. La sua vita e la sua fecondità
            attraverso le epoche non sono che il costante sfruttamento di questa
            confusione. (...) Quel che chiamiamo divertimento o evasione è
            soltanto uno smarrimento generale. L’ordine qui viene da un
            disordine. Nessuna delle manifestazioni del teatro obbedisce a una “
            linea di condotta “. Nessuno dei gesti o dei rituali del vero teatro
            deriva da una “tendenza”. Ricerche e preoccupazioni si agitano
            soltanto nel vago, nell’assente, nell’indeterminato: nel caos.
            (L.J.)
          </p>
        </div>

        <div className={classes.image_container}>
          <div className={classes.image} />
        </div>
      </div>
    </div>
  );
};

export default AboutMePage;
